import axios from 'axios';
import { baseUrl, HttpMethods } from '@/api/base';
import type {
  IDeleteApplicationEventService,
  IGetApplicationEventsService,
  IGetApplicationEventsServiceRes,
  IPatchApplicationEventService,
  IPostApplicationEventService,
} from './types';

export async function getApplicationEvents({
  params,
  applicationId,
}: IGetApplicationEventsService): Promise<IGetApplicationEventsServiceRes> {
  const res = await axios.request<IGetApplicationEventsServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/applications/${applicationId}/events`,
    params,
  });
  return res.data;
}

export async function postApplicationEvent({ data, applicationId }: IPostApplicationEventService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.ROVER}/applications/${applicationId}/events`,
    data,
  });
  return res.data;
}

export async function patchApplicationEvent({ applicationId, eventId, data }: IPatchApplicationEventService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.ROVER}/applications/${applicationId}/events/${eventId}`,
    data,
  });
  return res.data;
}

export async function deleteApplicationEvent({ applicationId, eventId }: IDeleteApplicationEventService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.ROVER}/applications/${applicationId}/events/${eventId}`,
  });
  return res.data;
}
